import { Injectable } from '@angular/core';

import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';
import { RECRUITEE_THEME_LS_KEY, SupportedThemesT, ThemeName } from '@recruitee/theme';

import { CurrentUserPreferencesHttpClient } from './current-user-preferences-http-client';
import { CurrentUserPreferencesActions } from './current-user-preferences.store';

@Injectable({ providedIn: 'root' })
export class CurrentUserPreferencesEffects {
  public effects = createEffectFactory(CurrentUserPreferencesActions, this.actions$);

  public fetchCurrentUserPreferences$ = this.effects(CurrentUserPreferencesActions.fetch, () =>
    this.currentUserPreferencesService
      .loadCurrentUserPreferences()
      .pipe(tap(data => this.cacheTheme(data.preferences.theme))),
  );

  public updateCurrentUserPreferences$ = this.effects(
    CurrentUserPreferencesActions.updatePreferredTheme,
    ({ payload }) => {
      const themeName = <SupportedThemesT>payload;
      this.cacheTheme(themeName);
      return of(
        CurrentUserPreferencesActions.update({
          payload: {
            preferences: {
              theme: payload,
            },
          },
        }),
      );
    },
  );

  public update$ = this.effects(CurrentUserPreferencesActions.update, ({ payload }) =>
    this.currentUserPreferencesService.updateCurrentUserPreferences(payload),
  );

  constructor(
    private store: Store,
    private actions$: Actions,
    private currentUserPreferencesService: CurrentUserPreferencesHttpClient,
  ) {}

  private cacheTheme(theme: ThemeName): void {
    localStorage.setItem(RECRUITEE_THEME_LS_KEY, theme);
  }
}
